import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as cssVariable from 'cssVariables';
import { injectStyles } from 'injectStyles';
import { supportedRoutes, supportedChildRoutes } from 'components/Search/searchDesignRoutes';
import { isTouch } from 'util/device';

const Title = ({ classes, gradientHeader, hideTitle, title, titleColor, url, path }) => (
  <h1
    className={classNames(classes.title, {
      [classes.titleIsHidden]: hideTitle,
      [classes.titleColor]: !!titleColor,
      [classes.fullWidth]: supportedRoutes.indexOf(url) >= 0 || supportedChildRoutes.indexOf(path) >= 0 || isTouch,
      [classes.smallTitle]: gradientHeader && isTouch,
      [classes.gradientHeaderDesktop]: gradientHeader && !isTouch,
      [classes.gradientHeader]: gradientHeader,
    })}
  >
    {title}
  </h1>
);

Title.defaultProps = {
  gradientHeader: false,
  hideTitle: false,
  title: null,
  titleColor: null,
  url: null,
  path: null,
};

Title.propTypes = {
  classes: PropTypes.object.isRequired,
  gradientHeader: PropTypes.bool,
  hideTitle: PropTypes.bool,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  url: PropTypes.string,
  path: PropTypes.string,
};

const styles = (theme) => ({
  title: {
    ...cssVariable.pageTitle,
    maxWidth: 'calc(100% - 210px)',
    position: 'relative',
  },
  gradientHeader: {
    color: theme.palette.gradientHeader.color,
    textAlign: 'center',
  },
  gradientHeaderDesktop: {
    maxWidth: '100%',
    textAlign: 'left',
  },
  smallTitle: {
    fontSize: cssVariable.fontSizes.small,
    textTransform: 'none',
  },
  titleIsHidden: cssVariable.screenReadersOnly,
  titleColor: ({ titleColor }) => ({
    color: titleColor === 'White' ? theme.palette.gradientHeader.color : theme.palette.text.primary,
  }),
  fullWidth: {
    maxWidth: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    title: {
      maxWidth: '100%',
    },
  },
});

export default injectStyles(styles)(Title);
